<template>
  <div class="bg-static-warning-mid rounded-md p-16">
    <div class="flex w-full flex-col">
      <h3 class="heading-3">{{ i18n(translations.title) }}</h3>
      <p class="body-1">{{ i18n(translations.subtitle) }}</p>

      <div class="my-16 flex items-center gap-4">
        <IconClock size="16" />
        <p class="body-2-bold">
          {{ i18n(translations.text) }}
        </p>
      </div>
    </div>

    <RevButton
      full-width="adaptive"
      :to="
        resolveLocalizedRoute({
          name: CUSTOMER_CARE.DIAGNOSIS.SELF,
          params: { orderlineId: params.uuid },
        })
      "
      :tracking="{
        name: 'go_help_center',
        zone: `reviews_page_${formStep + 1}`,
        pageType: 'review_form',
      }"
      variant="primary"
    >
      {{ i18n(translations.buttonTitle) }}
    </RevButton>
  </div>
</template>

<script lang="ts" setup>
import { useRoute } from '#imports'

import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevButton } from '@ds/components/Button'
import { IconClock } from '@ds/icons/IconClock'

import { useRouteLocationWithLocale } from '~/composables/useRouteLocationWithLocale'
import { CUSTOMER_CARE } from '~/scopes/customer-care/route-names'

import { useFormStep } from '../../composables/useFormStep'

import translations from './Care.translations'

const { formStep } = useFormStep()

const { params } = useRoute()

const resolveLocalizedRoute = useRouteLocationWithLocale()

const i18n = useI18n()
</script>
